import { GeneralConfigurationService } from './../services/general-configuration.service';
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

@Injectable()
export class ConfigResolver implements Resolve<any> {
  constructor(
    private configService: GeneralConfigurationService
  ) {}

  resolve() {
    return this.configService.resolverData();
  }
}
